export default "__VITE_ASSET__Cd88sDFA__"